<template>
	<div v-if="resource_group === 'default'" class="loaders--standard">

	</div>
	<div v-else-if="resource_group === 'gridlocked'" class="loaders--blocks">
		<div class="loaders--blocks-block"></div>
		<div class="loaders--blocks-block"></div>
		<div class="loaders--blocks-block"></div>

		<div class="loaders--blocks-block"></div>
		<div class="loaders--blocks-block"></div>
		<div class="loaders--blocks-block"></div>

		<div class="loaders--blocks-block"></div>
		<div class="loaders--blocks-block"></div>
		<div class="loaders--blocks-block"></div>
	</div>
</template>

<script>
	export default {
		name: "Loader"
	}
</script>